import { ComponentsOverrides, Theme } from '@mui/material'
import { THEME_SPACING } from './theme'

export default function alertTheme() {
  return {
    styleOverrides: styleOverrides()
  }
}

const styleOverrides = (): ComponentsOverrides<Theme>['MuiAlert'] => {
  return {
    root: ({ ownerState }) => {
      if (ownerState.severity === 'grey') {
        return {
          borderRadius: THEME_SPACING,
          border: `1px solid var(--${ownerState.severity}-50)`,
          color: `var(--${ownerState.severity}-500)`,
          backgroundColor: `var(--${ownerState.severity}-25)`,
          '& .MuiAlert-icon': {
            color: `var(--${ownerState.severity}-700)`
          }
        }
      }
      if (ownerState.severity === 'primary') {
        return {
          borderRadius: THEME_SPACING,
          border: `1px solid var(--${ownerState.severity}-50)`,
          color: `var(--${ownerState.severity}-500)`,
          backgroundColor: `var(--${ownerState.severity}-25)`,
          '& .MuiAlert-icon': {
            color: `var(--${ownerState.severity}-700)`
          }
        }
      }
      return {
        borderRadius: THEME_SPACING,
        border: `1px solid var(--${ownerState.severity}-200)`,
        color: `var(--${ownerState.severity}-700)`,
        backgroundColor: `var(--${ownerState.severity}-50)`,
        '& .MuiAlert-icon': {
          color: `var(--${ownerState.severity}-700)`
        }
      }
    }
  }
}
